import type { IconSvgObject } from './types';

const SpoolIcon: IconSvgObject = [
  ["path", { d: "M7 11L19.5951 6.95157C20.4323 6.68248 21 5.90369 21 5.02434C21 3.90633 20.0937 3 18.9757 3H5.02434C3.90633 3 3 3.90633 3 5.02434C3 5.90369 3.5677 6.68248 4.40487 6.95157L7 7.78571V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 13L4.40487 17.0484C3.5677 17.3175 3 18.0963 3 18.9757C3 20.0937 3.90633 21 5.02434 21H18.9757C20.0937 21 21 20.0937 21 18.9757C21 18.0963 20.4323 17.3175 19.5951 17.0484L17 16.2143V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SpoolIcon;
